var exports = {
  "i": "wrapper__l4udCj",
  "j": "connectedDot__0sTxvE",
};

module.exports = exports;
